import { render, staticRenderFns } from "./supervisionDialog.vue?vue&type=template&id=71dc97a9&scoped=true"
import script from "./supervisionDialog.vue?vue&type=script&lang=js"
export * from "./supervisionDialog.vue?vue&type=script&lang=js"
import style0 from "./supervisionDialog.vue?vue&type=style&index=0&id=71dc97a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc97a9",
  null
  
)

export default component.exports